import {Component, Inject, OnInit, Renderer2} from '@angular/core';
import {UserInfoService} from '../api/user-info.service';
import {UserInfoModel} from '../api/user-info-model';
import {DOCUMENT} from '@angular/common';
// tslint:disable-next-line:import-spacing
import {TechnicalApplicationSelectImageComponent}
from '../technical-applications/technical-application-select-image/technical-application-select-image.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LogoutComponent} from "../logout/logout.component";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  private userInfo: UserInfoModel;

  constructor(private userInfoService: UserInfoService,
              @Inject(DOCUMENT) private document: Document,
              private renderer: Renderer2,
              private modalService: NgbModal) { }

  async ngOnInit() {
    this.userInfo = await this.userInfoService.get().toPromise();
  }

  public toggleSidebar() {
    this.toggleSidebarClass();
    this.toggleBodyClass();
  }

  private toggleBodyClass() {
    const className = 'sidebar-toggled';

    if (this.document.body.classList.contains(className)) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }

  private toggleSidebarClass() {
    const sidebarId = 'sidebar';
    const className = 'toggled';

    const element = this.document.getElementById(sidebarId);
    if (element.classList.contains(className)) {
      this.renderer.removeClass(element, className);
    } else {
      this.renderer.addClass(element, className);
    }
  }

  logout() {
    const modalRef = this.modalService.open(LogoutComponent);
    const component: LogoutComponent = modalRef.componentInstance;
  }
}
